import { useCallback, useEffect, useRef, useState } from 'react';

const useHorizontalScrollFade = (enabled: boolean, deps: unknown[] = []) => {
  const [showRightFade, setShowRightFade] = useState(false);

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const updateFade = useCallback(() => {
    const el = scrollContainerRef?.current;

    if (!el) return;

    const { scrollLeft, scrollWidth, clientWidth } = el;

    const scrollRight = scrollWidth - clientWidth - Math.abs(scrollLeft);

    setShowRightFade(scrollRight > 1);
  }, []);

  useEffect(() => {
    const el = scrollContainerRef?.current;

    if (!enabled || !el) {
      setShowRightFade(false);
      return;
    }

    updateFade();

    el.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);

    return () => {
      el.removeEventListener('scroll', updateFade);
      window.removeEventListener('resize', updateFade);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ...deps]);

  return { showRightFade, scrollContainerRef };
};

export default useHorizontalScrollFade;
